/** @format */

import React, { useState, useEffect, useRef } from "react";
import { Nigerian_States } from "utils/constant.data";
import { ReactComponent as ResetIcon } from "images/svg/reset.svg";
import { toast } from "react-toastify";
// import DatePicker from "react-datepicker";
import { CustomSelect } from "../../Leaderboard/styles/customStyles";

const WebinarFilterModal = ({
    isVisible,
    setFilter,
    setFilterString,
    setIsFilterModalVisible,
    setActiveRecord,
}) => {
    const [selectedStates, setStates] = useState([]);
    const modalRef = useRef(null);

    const modalStyle = {
        position: "fixed",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
        width: "423px",
        zIndex: 1001,
    };


    useEffect(() => {
        const handleClickOutside = (event) => {
            if (
                modalRef.current &&
                !modalRef.current.contains(event.target) &&
                !event.target.closest(".react-select__container") &&
                !event.target.closest(".react-select__menu")
            ) {
                setIsFilterModalVisible(false);
            }
        };

        if (isVisible) {
            document.addEventListener("mousedown", handleClickOutside);
        }

        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [isVisible, setIsFilterModalVisible]);

    const StateOptions = Nigerian_States.map((state) => ({
        value: state,
        label: state,
    }));

    const handleReset = () => {
        setStates([]);
        setFilter(null);
        setFilterString("");
        setIsFilterModalVisible(false);
    };

    const handleApplyFilter = () => {
        if (selectedStates.length === 0) {
            toast.warn("✔️ Please Select a Filter !", {
                position: "top-right",
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
            });
        } else {
            setFilter({
                state: selectedStates.length > 0 ? selectedStates : [],
            });
            setActiveRecord(null);
            setIsFilterModalVisible(false);
        }
    };

    const isFilterSelected = () => {
        return selectedStates.length === 0;
    };

    

    if (!isVisible) return null;

    return (
        <>
            <div
                style={{
                    position: "fixed",
                    top: 0,
                    left: 0,
                    width: "100%",
                    height: "100%",
                    backgroundColor: "rgba(0, 0, 0, 0.5)",
                    zIndex: 1000,
                }}
            />
            <div className="filter-modal" style={modalStyle} ref={modalRef}>
                <div className="filter-modal-content">
                    <h6>Filter</h6>
                    <div className="filter-section">
                        <div className="filter-group">
                            <label>Category</label>
                            <CustomSelect
                                value={selectedStates}
                                onChange={setStates}
                                options={StateOptions}
                                placeholder="Filter by State"
                            />
                        </div>
                    </div>


                    {/* <div className="me-2">
                        <label>Start</label>
                        <div className="score-range-container calendar-input">
                            <DatePicker
                                className="form-control bg-transparent w-full w-100"
                                selected={date.start}
                                onChange={handleStartDateChange}
                                placeholder="Start Date"
                                showIcon={false}
                            />
                        </div>
                    </div> */}

                    <div className="filter-section">
                        <div className="filter-group">
                            <div className="score-range-container">
                                <button
                                    className="reset-filter table-reset"
                                    onClick={() => handleReset()}
                                >
                                    <ResetIcon />
                                    Reset Filter
                                </button>
                                <button
                                    className="show-results-button"
                                    disabled={isFilterSelected()}
                                    onClick={handleApplyFilter}
                                >
                                    Show Result
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default WebinarFilterModal;
